/**
 * Decision models (Jev, Trodo hartley-1) on /api/decision-models, plus the
 * team's decision-model integrations from /api/evals/integrations.
 */
import axiosInstance from 'shared/services/api/axiosInstance';

/** The team's saved decision models: [{ id, provider, label, default_model, ... }]. */
export async function listDecisionIntegrations(teamId) {
  const params = { kind: 'decision', ...(teamId != null ? { team_id: teamId } : {}) };
  const { data } = await axiosInstance.get('/evals/integrations', { params });
  return data?.integrations || [];
}

/** Providers and their models: [{ provider, label, live, default_model, models: [{id,label}] }]. */
export async function decisionCatalog(teamId) {
  const params = teamId != null ? { team_id: teamId } : {};
  const { data } = await axiosInstance.get('/decision-models/catalog', { params });
  return data?.providers || [];
}

/**
 * Ask the questions. body: { integration_id, model?, state, questions,
 * allow_abstain?, min_confidence? }. Resolves { model, provider, answers,
 * usage, latency_ms }; rejects with { message, code, retryable }.
 */
export async function decide(teamId, body) {
  try {
    const { data } = await axiosInstance.post('/decision-models/decide', { ...body, ...(teamId != null ? { team_id: teamId } : {}) });
    return data;
  } catch (e) {
    const d = e?.response?.data || {};
    const err = new Error(d.error || e.message || 'The model did not answer.');
    err.code = d.code || null;
    err.retryable = !!d.retryable;
    throw err;
  }
}
